export const fbConfig = {  "projectId": "taglinker-server",
  "appId": "1:1000586769793:web:5ecbb33b6552c435dce480",
  "storageBucket": "taglinker-server.appspot.com",
  "locationId": "us-central",
  "apiKey": "AIzaSyA_lUGuBojWgu6XosSWPTV6P-z_mWATpm0",
  "authDomain": "taglinker-server.firebaseapp.com",
  "messagingSenderId": "1000586769793",
  "measurementId": "G-WRV4PELTXM"}
